import api from 'services/api/microfwk';
import _ from 'lodash';
import qs from 'qs';

export const postPasswordReset = (body = {}) =>
  api
    .post('/services/user/password_reset', qs.stringify(body), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
